import 'react';
import { pm2SitemapStore, findPageDescriptorById } from '@pm2/sitemap-utils';
import { selectIsFavouritesEnabled, useToggleFavouriteMutation } from '@pm2/user-area';
import { useTrackingManager } from '@provider/tracking';
import { useUserIdentityState } from '@provider/user-identity';
import { Tooltip } from '@ui/kit';
import { HeartIcon } from '@ui/kit/icons';
import { button, icon } from './favourite-button.style.js';
import { jsx } from 'react/jsx-runtime';

function FavouriteButton(props) {
  const tracker = useTrackingManager();
  const isLoggedIn = useUserIdentityState(state => !!state.user);
  const isEnabled = pm2SitemapStore.useSelector(selectIsFavouritesEnabled);
  const descriptor = (() => {
    switch (props.descriptorType) {
      case "Course":
        return {
          type: "course",
          version: "1",
          courseId: props.descriptorId
        };
      case "Page":
        return {
          type: "page",
          version: "1",
          pageId: props.descriptorId
        };
    }
  })();
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const pageDescriptor = findPageDescriptorById(sitemap, props.descriptorId);
  const {
    addMutation,
    deleteMutation,
    isFavourite
  } = useToggleFavouriteMutation(descriptor);
  const handleToggle = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    if (addMutation.isPending || deleteMutation.isPending) {
      return;
    }
    const trackingContext = {
      context: "cards",
      targetId: props.descriptorId,
      targetPath: pageDescriptor?.path ?? "",
      targetTitle: pageDescriptor?.title ?? "",
      targetType: pageDescriptor?.type ?? "Page"
    };
    if (isFavourite) {
      deleteMutation.mutate();
      tracker.trackEvent("userarea.favourites.delete", trackingContext);
    } else {
      addMutation.mutate();
      tracker.trackEvent("userarea.favourites.add", trackingContext);
    }
  };
  if (!isLoggedIn || !isEnabled) {
    return null;
  }
  return /*#__PURE__*/jsx(Tooltip, {
    ariaType: "label",
    placement: "top",
    body: isFavourite ? "Fjern fra favoritter" : "Tilføj til favoritter",
    children: ref => /*#__PURE__*/jsx("button", {
      ref: ref,
      className: button,
      onClick: handleToggle,
      tabIndex: props.tabIndex,
      children: /*#__PURE__*/jsx(HeartIcon, {
        className: icon,
        "data-favourite": isFavourite
      })
    })
  });
}

export { FavouriteButton };
//# sourceMappingURL=favourite-button.js.map
